import * as React from 'react';
import {TableRow, TableCell} from '../TableRow';
import {Tt4a} from '../../../../../../../../components/Typography/Tt4a';
import {OrderCell} from './components/OrderCell';
import {IMarkupsOrder} from '../../../../../../interfaces/IMarkupsTab';

const getCells = (props: IHeaderRowProps) => [
  <TableCell key={1} content={<Tt4a style={{color: '#8D919A'}} content="Type / Category / Notes" />} />,
  <TableCell
    key={2}
    content={<OrderCell title="Timecode In" order={props.markupsOrder} onOrderChange={props.onOrderChange} />}
  />,
  <TableCell key={3} content={<Tt4a style={{color: '#8D919A'}} content="Timecode Out" />} />,
  <TableCell className="header-row_action-cell" key={4} content={<Tt4a style={{color: '#8D919A'}} content="" />} />
];

interface IHeaderRowProps {
  markupsOrder: IMarkupsOrder;
  onOrderChange: (order: IMarkupsOrder) => void;
}

export const HeaderRow = (props: IHeaderRowProps) => <TableRow className="header-row" cells={getCells(props)} />;
